module.exports = __webpack_public_path__ + "img/6.db3b8cf2.png";